import {
    Conditions, 
    GroupConditions, 
    ItemConditions,
} from "./SegmentModel";

// 選択条件 値取得
export function GetCoordinateValue(data: any, conditionType: string, groupAndor: string) {
    var arrayCondition = Object.keys(data).map((k)=>({ key: k, value: data[k] }));
    let reg = new RegExp(conditionType + "-", "g");
    var conditions = arrayCondition.filter(value => value.key.match(reg));

    // グループ key取得
    let groupKeys: any = [];
    conditions.map((val: any) => {
      let valKey = val.key;
      let splitValKey = valKey.split("-");
      let key1 = splitValKey[0]+"-"+splitValKey[1];

      if (groupKeys.indexOf(key1) === -1) {
        groupKeys.push(key1);
      }
    });

    let groupConditions1: Array<GroupConditions> = [];

    // グループごとの条件取得
    groupKeys.map((val1: any) => {
      let itemConditions1: Array<ItemConditions> = [];

      var groupConditions = arrayCondition.filter(value => value.key.match(val1));
      let groupAndOr: string = "";
      let itemKeys: any = [];

      // アイテム key取得
      groupConditions.map((val2: any) => {
        let val2Key = val2.key;
        let splitVal2Key = val2Key.split("-");
        let key1 = splitVal2Key[0]+"-"+splitVal2Key[1]+"-"+splitVal2Key[2];

        if (val2.key.indexOf("InnerAndOr") >= 0) {
          groupAndOr = val2.value;
          return;
        }

        if (itemKeys.indexOf(key1) === -1) {
          itemKeys.push(key1);
        }
      });

      // アイテムごとの条件取得
      itemKeys.map((val2: any) => {
        var itemConditions = arrayCondition.filter(value => value.key.match(val2+"-"));

        let first1: string = "";
        let second1: string = "";
        let third1: string = "";
        let arrayAnswer1: any = [];

        // アイテム条件セット
        itemConditions.map((val3: any) => {
          if (val3.key.indexOf("first") >= 0) {
            first1 = val3.value;
          }
          if (val3.key.indexOf("second") >= 0) {
            second1 = val3.value;
          }
          if (val3.key.indexOf("third") >= 0) {
            third1 = val3.value;
          }
        });

        let subcategory1: string = "";
        let subSubcategory1: string = second1;

        if (third1 !== "") {
          subcategory1 = second1
          subSubcategory1 = third1
        }

        var answers = itemConditions.filter(value => value.key.match("answer"));

        let field1: string = "";

        if (answers.length === 2) {
          field1 = "range"
          arrayAnswer1.push(answers[0].value);
          arrayAnswer1.push(answers[1].value);
        } else {
          let splitVal1: string[] = answers[0].key.split("_");

          field1 = splitVal1[1]
          if (splitVal1[1] === "multi") {
            let t1 = answers[0].value;

            for (let item in t1) {
              if (t1[item]) {
                arrayAnswer1.push(t1[item]);
              }
            }
          }
          if (splitVal1[1] === "text") {
            arrayAnswer1.push(answers[0].value);
          }
        }

        let itemCondition1: ItemConditions = {
          id: val2,
          category: first1,
          subcategory: subcategory1,
          subSubcategory: subSubcategory1,
          field: field1,
          value: arrayAnswer1,
        };
        itemConditions1.push(itemCondition1);
      });

      if (val1.indexOf('InnerAndOr') < 0) {
        let splitVal1 = val1.split("-");
        let groupId = "group-" + conditionType + splitVal1[1];
  
        // グループ条件セット
        let groupCondition1: GroupConditions = {
          id: groupId,
          operation: groupAndOr,
          itemConditions: itemConditions1,
        }
        groupConditions1.push(groupCondition1);
      }
    });

    let conditions1: Conditions = {
      groupOperation: groupAndor,
      groupConditions: groupConditions1,
    }

    return conditions1
};